/* Package JSON Import will be here */
import { S3Client, PutObjectCommand, CopyObjectCommand, DeleteObjectCommand } from "@aws-sdk/client-s3";
/* Package JSON Import will be here */

const getS3Client = (awsConfig) => {
	return new S3Client({
		region: awsConfig.EndPoint.split(".")[1],
		credentials: {
			accessKeyId: awsConfig.AccessKey,
			secretAccessKey: awsConfig.SecretKey
		}
	});
};

export const uploadImageToS3 = ({ folderPath, fileName, file, awsConfig }) => {
	const s3Client = getS3Client(awsConfig);

	const command = new PutObjectCommand({
		Bucket: awsConfig.BucketName,
		Key: `${folderPath}${fileName}`,
		Body: file
	});

	return s3Client.send(command)
		.then(() => `${awsConfig.Host}/${folderPath}${fileName}`)
		.catch(err => Promise.reject(err));
};

export const moveFileInS3 = ({ sourceFilePath, destinationFilePath, awsConfig }) => {
	const s3Client = getS3Client(awsConfig);

	const copyCommand = new CopyObjectCommand({
		Bucket: awsConfig.BucketName,
		CopySource: `/${awsConfig.BucketName}/${sourceFilePath}`,
		Key: destinationFilePath
	});

	return s3Client.send(copyCommand)
		.then(() => {
			const deleteCommand = new DeleteObjectCommand({
				Bucket: awsConfig.BucketName,
				Key: sourceFilePath
			});
			s3Client.send(deleteCommand)
				.then(data => console.log('Target file deleted from temp folder - ', data))
				.catch(err => console.error("Some error occurred during delete the file from temp folder, But it will be auto purged within 7 days - ", err));

			return true;
		})
		.catch(() => Promise.reject(false));
};
